"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var shared_1 = require("@formily/shared");
var context_1 = require("./context");
exports.PreviewText = function (props) {
    var context = react_1.useContext(context_1.PreviewTextContext) || {};
    var value;
    if (props.dataSource && props.dataSource.length) {
        if (Array.isArray(props.value)) {
            value = props.value.map(function (val, index) {
                var finded = props.dataSource.find(function (item) { return item.value == val || shared_1.isEqual(item.value, val); });
                if (finded) {
                    return (react_1.default.createElement("span", { key: index },
                        finded.label,
                        index < props.value.length - 1 ? ' ,' : ''));
                }
            });
        }
        else {
            var fined = props.dataSource.find(function (item) {
                return shared_1.isEqual(item.value, props.value);
            });
            if (fined) {
                value = fined.label;
            }
        }
    }
    else {
        if (Array.isArray(props.value)) {
            value = props.value.map(function (val, index) {
                return (react_1.default.createElement("span", { key: index },
                    val,
                    index < props.value.length - 1 ? '~' : ''));
            });
        }
        else {
            value = String(props.value === undefined || props.value === null ? '' : props.value);
            if (value.match('\n')) {
                value = value
                    .split('\n')
                    .map(function (subStr, index) { return react_1.default.createElement("div", { key: index }, subStr); });
            }
        }
    }
    var placeholder = shared_1.isFn(context.previewPlaceholder)
        ? context.previewPlaceholder(props)
        : context.previewPlaceholder;
    return (react_1.default.createElement("p", { style: { padding: 0, margin: 0 }, className: "preview-text " + (props.className || '') },
        props.addonBefore ? ' ' + props.addonBefore : '',
        props.innerBefore ? ' ' + props.innerBefore : '',
        props.addonTextBefore ? ' ' + props.addonTextBefore : '',
        value === '' ||
            value === undefined ||
            (Array.isArray(value) && value.length === 0)
            ? placeholder || 'N/A'
            : value,
        props.addonTextAfter ? ' ' + props.addonTextAfter : '',
        props.innerAfter ? ' ' + props.innerAfter : '',
        props.addonAfter ? ' ' + props.addonAfter : ''));
};
exports.PreviewText.ConfigProvider = context_1.PreviewTextContext.Provider;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-shared-components/lib/PreviewText.js
// module id = 4672
// module chunks = 0